import axios from './network.js'

let publicAPI = {
  // 支付宝支付
  clickPay: function (data, success, failure) {
    return axios.postJson("/Home/Pay/createAlipayOrder", data, success, failure);
  },
  // 邮箱登录
  emailLogin: function (data, success, failure) {
    return axios.postJson("/Home/Login/Login", data, success, failure);
  },
  // 注册
  userRegister: function (data, success, failure) {
    return axios.postJson("/Home/Login/register", data, success, failure);
  },
  // 获取国家列表
  getCountry: function (data, success, failure) {
    return axios.postJson("/Home/Common/getCountry", data, success, failure);
  },
  // 获取省列表
  getProvince: function (data, success, failure) {
    return axios.postJson("/Home/Common/getProvince", data, success, failure);
  },
  // 获取市列表
  getCity: function (data, success, failure) {
    return axios.postJson("/Home/Common/getCity", data, success, failure);
  },
  // 获取区列表
  getArea: function (data, success, failure) {
    return axios.postJson("/Home/Common/getArea", data, success, failure);
  },
  // 发送忘记密码验证码邮件
  sendFindPasswordEmail: function (data, success, failure) {
    return axios.postJson("/Home/Login/sendFindPasswordEmail", data, success, failure);
  },
  // 验证邮箱验证码
  checkEmailCode: function (data, success, failure) {
    return axios.postJson("/Home/Login/checkEmailCode", data, success, failure);
  },
  // 修改手机号
  updateMobile: function (data, success, failure) {
    return axios.postJson("/Home/Login/updateMobile", data, success, failure);
  },
   // 修改手机号
   updateEmail: function (data, success, failure) {
    return axios.postJson("/Home/Login/updateEmail", data, success, failure);
  },
  // 忘记密码
  forgetPassword: function (data, success, failure) {
    return axios.postJson("/Home/Login/forget", data, success, failure);
  },
  // 修改密码
  updatePassword: function (data, success, failure) {
    return axios.postJson("/Home/User/updatePassword", data, success, failure);
  },
  // 博客----------API
  // 博客类型列表
  getBlogType: function (data, success, failure) {
    return axios.postJson("/Home/Common/getBlogType", data, success, failure);
  },
  // 获取博客列表
  blogList: function (data, success, failure) {
    return axios.postJson("/Home/Common/blogList", data, success, failure);
  },
  // 博客详情
  blogDetail: function (data, success, failure) {
    return axios.postJson("/Home/Common/blogDetail", data, success, failure);
  },
  // 评论博客
  blogComment: function (data, success, failure) {
    return axios.postJson("/Home/Common/blogComment", data, success, failure);
  },
  // 关于我们
  aboutUs: function (data, success, failure) {
    return axios.postJson("/Home/Common/aboutUs", data, success, failure);
  },
  // 论坛-----------API
  // 获取用户论坛类型
  getUserBlogType: function (data, success, failure) {
    return axios.postJson("/Home/User/getUserBlogType", data, success, failure);
  },
  // 获取用户论坛列表
  forumList: function (data, success, failure) {
    return axios.postJson("/Home/Common/forumList", data, success, failure);
  },
  // 获取用户论坛详情
  forumDetail: function (data, success, failure) {
    return axios.postJson("/Home/Common/forumDetail", data, success, failure);
  },
  // 发布帖子
  addBlog: function (data, success, failure) {
    return axios.postJson("/Home/User/addBlog", data, success, failure);
  },
  // 回复论坛
  reply: function (data, success, failure) {
    return axios.postJson("/Home/User/reply", data, success, failure);
  },
  // 首页获取热词
  getHotWordList: function (data, success, failure) {
    return axios.postJson("/Home/Index/getHotWordList", data, success, failure);
  },
  // 获取导航栏
  getMenuList: function (data, success, failure) {
    return axios.postJson("/Home/Index/getMenuList", data, success, failure);
  },
  // 获取页面底部
  getBottomList: function (data, success, failure) {
    return axios.postJson("/Home/Index/getBottomList", data, success, failure);
  },
  // 获取页面底部详情
  getBottomDetail: function (data, success, failure) {
    return axios.postJson("/Home/Index/getBottomDetail", data, success, failure);
  },
  //获取购物车数量
  getCartNum: function (data, success, failure) {
    return axios.postJson("/Home/User/getCartNum", data, success, failure);
  },
  // 订阅
  subscribe: function (data, success, failure) {
    return axios.postJson("/Home/User/subscribe", data, success, failure);
  },
  // 翻译 - 单个词
  translate: function (data, success, failure) {
    return axios.postJson("/Home/Login/translate", data, success, failure);
  },
  // 翻译 - 数组
  translateByArr: function (data, success, failure) {
    return axios.postJson("/Home/Common/translateArr", data, success, failure);
  },
  // banner列表
  getBannerList: function (data, success, failure) {
    return axios.postJson("/Home/Index/getBannerList", data, success, failure);
  },
  // 发送运费咨询
  addData:function (data, success, failure) {
    return axios.postJson("/Home/Chat/addData", data, success, failure);
  },
  // 获取咨询运费列表信息
  getList:function (data, success, failure) {
    return axios.postJson("/Home/Chat/getList", data, success, failure);
  },
  // 获取网站logo以及名称
  getSystemConfig:function (data, success, failure) {
    return axios.postJson("/Home/Index/getSystemConfig", data, success, failure);
  },
  // 判断ip地址
  getIpAddress:function (data, success, failure) {
    return axios.postJson("/Home/Common/getIpAddress", data, success, failure);
  },
}

export default publicAPI



// WEBPACK FOOTER //
// ./src/api/publicAPI.js